module.exports = __webpack_public_path__ + "img/address.8da477b0.svg";